// eslint-disable-next-line import/no-extraneous-dependencies
import gql from 'graphql-tag';

export const GET_TRENDING_FURNITURE_DATA = gql`
  query trendingFurniture {
    trendingFurniture {
      id
      title
      brand
      url
      slug
      price {
        price
        msrp
      }
      reviews {
        number
        rating
      }
      image {
        style
        alt
        src
        classes
        sources {
          media
          srcset
        }
      }
    }
  }
`;

export const GET_DYNAMIC_BANNER_DATA = gql`
  query dynamicBanner {
    allFurniture {
      dynamicBanner {
        center {
          slug
          content {
            html
            style
          }
          background {
            alt
            banner
            video
          }
          speed
          displayPage
          internalRoute
          isMobile
          isTablet
          isDesktop
        }
      }
    }
  }
`;
